
<form #f="ngForm" *ngIf="displayMode==2"
      novalidate (ngSubmit)="save(f)">

  <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
    <div class="row padding-sm-vr"  *ngIf="itemBrands &&!visitsByItems">
      <div class="col-sm-12">
        <div [ngClass]="{'has-success': (brandId.dirty || brandId.touched || f.submitted)  && brandId.valid, 'has-error' : (brandId.dirty || brandId.touched || f.submitted)  && brandId.invalid}">
          <label class="control-label" for="brandId-{{uniqueId}}">{{'representation.itemsBrands' | translate}}</label>
          <span class="ui-fluid">
            <p-dropdown [options]="itemBrands"
                        styleClass="wid100"
                        placeholder="Item Brands"
                        emptyFilterMessage="No results found"
                        showClear="true"
                        name="brandId" #brandId="ngModel"
                        required="required" [(ngModel)]="representationItem.itemBrand"
                        [filter]="true" optionLabel="name"></p-dropdown>
          </span>
          <div *ngIf="(brandId.dirty || brandId.touched || f.submitted)  && brandId.invalid" class="jquery-validate-error help-block">
            {{'app.RequiredField' | translate}}
          </div>
        </div>
      </div>
    </div>

    <div class="row padding-sm-vr"  *ngIf="items &&visitsByItems">
      <div class="col-sm-12">
        <div [ngClass]="{'has-success': (itemId.dirty || itemId.touched || f.submitted)  && itemId.valid, 'has-error' : (itemId.dirty || itemId.touched || f.submitted)  && itemId.invalid}">
          <label class="control-label" for="itemId-{{uniqueId}}">{{'Items' | translate}}</label>
          <span class="ui-fluid">
            <p-dropdown [options]="items"
                        styleClass="wid100"
                        placeholder="Items"
                        emptyFilterMessage="No results found"
                        showClear="true"
                        name="itemId" #itemId="ngModel"
                        required="required" [(ngModel)]="representationItem.item"
                        [filter]="true" optionLabel="name"></p-dropdown>
          </span>
          <div *ngIf="(itemId.dirty || itemId.touched || f.submitted)  && itemId.invalid" class="jquery-validate-error help-block">
            {{'app.RequiredField' | translate}}
          </div>
        </div>
      </div>
    </div>


    <div class="row padding-sm-vr">
      <div class="col-sm-6">
        <div [ngClass]="{'has-success': (order.dirty || order.touched || f.submitted)  && order.valid, 'has-error' : (order.dirty || order.touched || f.submitted)  && order.invalid}">
          <label class="control-label">{{'representation.order' | translate}} </label>
          <input type="number" required="required"
                 name="order"
                 [(ngModel)]="representationItem.order"
                 #order="ngModel"
                 class="form-control" />
          <div *ngIf="(order.dirty || order.touched || f.submitted)  && order.invalid" class="jquery-validate-error help-block">
            {{'app.RequiredField' | translate}}
          </div>
        </div>
      </div>

    </div>
    <div class="row padding-sm-vr">
      <div class="col-sm-6">
        <div [ngClass]="{'has-success': (url.dirty || url.touched || f.submitted)  && url.valid, 'has-error' : (url.dirty || url.touched || f.submitted)  && url.invalid}">
          <label class="control-label">{{'representation.url' | translate}} </label>
          <input type="text"
                 name="url"
                 [(ngModel)]="representationItem.url"
                 #url="ngModel"
                 class="form-control" />
          <div *ngIf="(url.dirty || url.touched || f.submitted)  && url.invalid" class="jquery-validate-error help-block">
            {{'app.RequiredField' | translate}}
          </div>
        </div>
      </div>

    </div>

    <div class="row padding-sm-vr">
      <div class="col-sm-6">
        <div [ngClass]="{'has-success': (startDatePicker.dirty || startDatePicker.touched || f.submitted)  && startDatePicker.valid, 'has-error' : (startDatePicker.dirty || startDatePicker.touched || f.submitted)  && startDatePicker.invalid}">
          <label class="control-label">{{'items.StartDate' | translate}} </label>
          <div class="input-group date">
            <input class="form-control" placeholder="yyyy-mm-dd" required
                   name="startDatePicker" #startDatePicker="ngModel"
                   [(ngModel)]="startDate" ngbDatepicker #dpYMD="ngbDatepicker" [maxDate]="endDate">
            <span class="input-group-btn date-label">
              <button class="btn date-btn" (click)="dpYMD.toggle()" type="button"><i class="fa fa-calendar"></i></button>
            </span>


          </div>
          <div *ngIf="(startDatePicker.dirty || startDatePicker.touched || f.submitted)  && startDatePicker.invalid" class="jquery-validate-error help-block">
            {{'app.RequiredField' | translate}}
          </div>
        </div>
      </div>
      <div class="col-sm-6" *ngIf="!representationItem.isCurrent">
        <div [ngClass]="{'has-success': (endDatePicker.dirty || endDatePicker.touched || f.submitted)  && endDatePicker.valid, 'has-error' : (endDatePicker.dirty || endDatePicker.touched || f.submitted)  && endDatePicker.invalid}">
          <label class="control-label">{{'items.endDate' | translate}} </label>
          <div class="input-group date">
            <input class="form-control" placeholder="yyyy-mm-dd" [required]="representationItem.isCurrent===false" [minDate]="startDate"
                   name="endDatePicker" #endDatePicker="ngModel"
                   [(ngModel)]="endDate" ngbDatepicker #dpYMD="ngbDatepicker">

            <span class="input-group-btn date-label">
              <button class="btn date-btn" (click)="dpYMD.toggle()" type="button"><i class="fa fa-calendar"></i></button>
            </span>


          </div>
          <div *ngIf="(endDatePicker.dirty || endDatePicker.touched || f.submitted)  && endDatePicker.invalid" class="jquery-validate-error help-block">
            {{'app.RequiredField' | translate}}
          </div>
        </div>
      </div>



    </div>
    <div class="row padding-sm-vr">
      <div class="col-sm-6">
        <div [ngClass]="{'has-success': (isCurrent.dirty || isCurrent.touched || f.submitted)  && isCurrent.valid, 'has-error' : (isCurrent.dirty || isCurrent.touched || f.submitted)  && isCurrent.invalid}">
          <label class="control-label">{{'items.isCurrent' | translate}} </label>
          <div class="form-group">
            <div class="checkbox">
              <label><input type="checkbox" #isCurrent="ngModel" name="isCurrent" [(ngModel)]="representationItem.isCurrent">{{'Is Current' | translate}}  </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="panel-footer margin-left-20 margin-top-20 margin-left-20">
      <button class="btn  btn-cancel" type="button" (click)="close()">{{'app.cancel' | translate}}</button>&nbsp;
      <button class="btn  btn-save" type="submit">{{'app.save' | translate}}</button>

    </div>


  </div>

</form>
<div class="row col-sm-12 padding-sm-hr" *ngIf="displayMode==3">
  <div class="alert alert-danger alert-dark">
    <button type="button" class="close" data-dismiss="alert">×</button>
    {{'app.ServerError' |translate}}.
  </div>
</div>

<div class="row col-sm-12 padding-sm-hr" *ngIf="displayMode==1">
  <div class="container text-center">
    <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
  </div>

</div>

